var _path, _rect, _rect2, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5891 3L10.5891 1.5C10.5891 0.67157 9.91754 -3.41731e-08 9.08911 -7.63276e-08L1.84084 -4.45156e-07C1.01241 -4.8731e-07 0.340839 0.671569 0.340839 1.5L0.340839 12.3042C0.340839 13.1326 1.01241 13.8042 1.84084 13.8042L9.08911 13.8042C9.91754 13.8042 10.5891 13.1326 10.5891 12.3042L10.5891 11L9.58911 11L9.58911 12.3042C9.58911 12.5803 9.36525 12.8042 9.08911 12.8042L1.84084 12.8042C1.5647 12.8042 1.34084 12.5803 1.34084 12.3042L1.34084 1.5C1.34084 1.22385 1.5647 1 1.84084 1L9.08911 1C9.36525 1 9.58911 1.22386 9.58911 1.5L9.58911 3L10.5891 3Z",
    fill: "#DD2207"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60034,
    y: 4,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 9.60034 4)",
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.60034,
    y: 12.4893,
    width: 2.62936,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 9.60034 12.4893)",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93079 6.7821C5.93079 6.41906 6.22509 6.12476 6.58813 6.12476L14.5901 6.12476C14.9531 6.12476 15.2474 6.41906 15.2474 6.7821C15.2474 7.14514 14.9531 7.43944 14.5901 7.43944L6.58813 7.43944C6.22509 7.43944 5.93079 7.14513 5.93079 6.7821Z",
    fill: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9397 10.5659C11.6904 10.302 11.6904 9.87422 11.9397 9.61034L14.9489 6.42567C15.1982 6.16179 15.6024 6.16179 15.8518 6.42567C16.1011 6.68954 16.1011 7.11737 15.8518 7.38125L12.8426 10.5659C12.5933 10.8298 12.1891 10.8298 11.9397 10.5659Z",
    fill: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4253 3.59901C12.6746 3.33513 13.0788 3.33513 13.3282 3.59901L15.8894 6.30965C16.1387 6.57353 16.1387 7.00135 15.8894 7.26523C15.6401 7.52911 15.2358 7.52911 14.9865 7.26523L12.4253 4.55459C12.1759 4.29071 12.1759 3.86288 12.4253 3.59901Z",
    fill: "#D91F05"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.61185217.svg";
export { ForwardRef as ReactComponent };